/* eslint-disable max-len */
export default {
  ACTIONS: {
    HOME: 'Inicio',
    LOGOUT: 'Cerrar sesión',
    NEXT: 'Siguiente',
    SUBMIT: 'Enviar',
    USERS: 'Usuarios'
  },
  ERRORS: {
    BASE:
      'Se ha producido un error. ¡Lo sentimos! Inténtalo de nuevo en unos minutos. 🥴'
  },
  MESSAGES: {
    NOT_FOUND: 'Página no encontrada',
    ORDER: 'Pedido',
    OTHER: 'Otro',
    OTHER_RET: 'Otro…',
    PROZIS_NOW: 'PROZIS NOW',
    UNAUTHORIZED: 'Sin acceso'
  },
  SENTENCES: {
    NOT_FOUND: 'Lo sentimos, no hemos encontrado lo que buscas.',
    UNAUTHORIZED:
      'Lo sentimos, no tienes permiso para acceder a este recurso. Ponte en contacto con nosotros si necesita acceder al mismo.'
  }
};
